import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class HelpInfo {
    info = null;

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 初始化
     */
    init() {
        this.info = null;
    }

    /**
     *
     * @param {*} id
     */
    async fetchInfo(id) {
        try {
            const {info} = await Api.helpInfo({id});

            //   const { id, title, content, preArticle, nextArticle } = info;

            this.info = info;
        } catch (error) {
        }
    }
}

const store = new HelpInfo();

export default store;
